{
  "api": {
    "locationValidationTitle": "위치를 확인할 수 없습니다",
    "thresholdTitle": "체크인 가능 시간이 아닙니다",
    "warehouseUnavailableTitle": "창고를 이용할 수 없습니다",
    "warehouseUnavailableMessage": "수동 체크인을 진행하려면 시설 담당자에게 문의하세요",
    "characterLimitTitle": "입력이 글자 수 제한을 초과했습니다",
    "genericTitle": "체크인에 실패했습니다. 다시 시도해 주세요.",
    "recaptchaTitle": "인증 실패",
    "recaptchaMessage": "요청을 확인할 수 없습니다. 다시 시도하거나 시설 담당자에게 문의하세요."
  }
}
